import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Receives a token handed off from the CLTS Portal:
//   /sso?token={JWT}&u={base64(encodeURIComponent(JSON.stringify(user)))}
// Stores it in localStorage, strips the URL, and redirects into the app.
export default function SsoLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const u = params.get('u');

    if (!token) {
      setError('No token provided');
      setTimeout(() => navigate('/login'), 1500);
      return;
    }

    try {
      localStorage.setItem('token', token);
      localStorage.setItem('loginSource', 'portal');
      if (u) {
        const userJson = decodeURIComponent(atob(u));
        localStorage.setItem('user', userJson);
      }
      // Strip token from the address bar so it isn't bookmarked/shared
      window.history.replaceState({}, document.title, '/');
      navigate('/');
    } catch (e) {
      setError('Invalid SSO payload');
      setTimeout(() => navigate('/login'), 1500);
    }
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🔐</div>
        <div style={{ fontSize: 16, fontWeight: 600 }}>
          {error || 'Signing you in...'}
        </div>
      </div>
    </div>
  );
}
